import React from 'react'
import { withRouter } from 'react-router-dom'
import { Tabs } from 'antd'
import '../Merchandise/style.css'
import SaleRecord from '../components/saleRecord'
import StoreRecord from '../components/storeRecord'
import StockRecord from '../components/stockRecord'

const { TabPane } = Tabs

class Statement extends React.Component {
  state = {}

  componentDidMount() {}

  render() {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="销售记录" key="1">
            <SaleRecord></SaleRecord>
          </TabPane>
          <TabPane tab="进出记录" key="2">
            <StoreRecord></StoreRecord>
          </TabPane>
          <TabPane tab="商品库存" key="3">
            <StockRecord></StockRecord>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}
export default withRouter(Statement)



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/Statement/index.js